export const URL_PDF = 'https://www.openbank.es/assets/static/onboarding/pdf/';
export const TERMS_PDF =
    'terminos_de_uso_y_politica_de_privacidad_del_sistema_de_identificacion_por_videoconferencia_openbank.pdf';
